import Ranger from './Ranger';

export default Ranger;
